import axios from "../../../../../../api/axiosInstance";
import { SyncMemberDashboardResponse } from "./types";

/**
 * Rebuilds the member's rollups — both halves — then the page refetches.
 *
 * No body and no parameters: the company comes from the session, the same way
 * the dashboard's own request works.
 *
 * **This cannot pull fresh figures out of QuickBooks or ServiceTitan.** Both
 * halves are rebuilt from what has already been delivered — QuickBooks to the
 * reporting warehouse, ServiceTitan to unification — so a member who posts
 * something in either and presses this immediately will see no change until the
 * next import lands.
 *
 * **Rejects with 409 when a rebuild is already running for this member.** The
 * nightly sweep calls the same rebuild, so a member who refreshes while it is
 * on them is refused rather than queued — waiting would hold the request open
 * for the sweep's whole slice of them. Nothing was changed and retrying later
 * works, but the axios interceptor toasts it like any other failure.
 */
export const syncMemberDashboard =
  async (): Promise<SyncMemberDashboardResponse> => {
    const response = await axios.post<SyncMemberDashboardResponse>(
      "/api/private/member-dashboard/sync",
    );
    return response.data;
  };
